import { Stack, InputAdornment, TextField, MenuItem } from '@mui/material';
// components
import Iconify from '../../../../components/Iconify';

// ----------------------------------------------------------------------

type Props = {
  optionsRole: string[];
  filterName: string;
  filterRole: string;
  placeholder?: string;
  onFilterName: (value: string) => void;
  small?: boolean;
  onFilterRole: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

export default function UserTableToolbar({
  filterName,
  filterRole,
  onFilterName,
  onFilterRole,
  optionsRole,
  placeholder,
  small,
}: Props) {
  return (
    <Stack
      spacing={2}
      direction={{ xs: 'column', sm: small ? 'row-reverse' : 'row' }}
      sx={{ py: 2.5, px: 3 }}
      justifyContent={small ? 'space-between' : 'flex-start'}
    >
   

      <TextField
        fullWidth={small ? false : true}
        value={filterName}
        onChange={(event) => onFilterName(event.target.value)}
        placeholder={placeholder ? placeholder : 'Search user...'}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Iconify
                icon={'eva:search-fill'}
                sx={{ color: 'text.disabled', width: 20, height: 20 }}
              />
            </InputAdornment>
          ),
        }}
      />
    </Stack>
  );
}

const SearchBar = () => {};
